<template>
  <!-- 错误弹框 -->
  <div>
    <div class="errorClass" v-if="show">
      <div class="content">
        <div class="top">
          <img src="../../../assets/img/noticeLB.png" alt="" />
          <span> 提示 </span>
        </div>
        <div class="con">
          {{ noticeCon }}
        </div>
        <div class="reason">
          <p>{{errMsg}}</p>
          <p>{{reason}}</p>
        </div>
        <div class="bot">
          <van-button round block type="info" @click="close" class="btn"
            >确认
               <img class="blueSha" src="../../../assets/img/blueshadow.png" alt="" />
            </van-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
    },
    notice: {
      type: String,
    },
    errMsg:{
      type: String,
    },
    reason:{
      type:String,
      default:''
    }
  },
  watch: {
    show: {
      handler(val) {
        if (val) {
          this.noticeCon = this.notice;
        }
      },
    },
  },
  data() {
    return {
      noticeCon: "",
      // showModel: false,
      // showError:false,
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style lang='scss' scoped>
.errorClass {
  .bot {
    padding: 0px 20px;
    ::v-deep .van-button--info{
    border: none !important;
    outline: none !important;
  }
    .btn {
      background-image: linear-gradient(-45deg, #54adfb 0%, #297bf4 100%);
      border-radius: 22px;
      margin-top: 32px;
      margin-bottom: 40px;

      font-size: 18px;
      color: #ffffff;
      letter-spacing: 0;
      font-weight: 700;
      position: relative;
      .blueSha{
        width: 266px;
        height: 34px;
        position: absolute;
        left: 50%;
        top: 68%;
        transform: translateX(-50%);
      }
    }
  }

  position: fixed;
  z-index: 1000;
  height: 100vh;
  width: 100vw;
  background: rgba(0, 0, 0, 0.5);
  top: 0%;
  left: 50%;
  transform: translateX(-50%);
  .content {
    border-radius: 10px;
    position: absolute;
    top: 46%;
    left: 50%;
    width: 344px;
    // height: 268px;
    transform: translate(-50%, -50%);
    background: #fff;
    line-height: 26px;
    .top {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 33px;
      margin-bottom: 33px;
      > img {
        width: 30px;
        height: 30px;
      }
      span {

        font-size: 18px;
        color: #464a4c;
        letter-spacing: 0;
        font-weight: 600;
        margin-left: 7px;
      }
    }
    .con {
      padding: 0px 20px;

      font-size: 16px;
      color: #464a4c;
      letter-spacing: 0;
      font-weight: 600;

    }
    .reason{
      background: #F1F1F1;
      border-radius: 4px;
      width:304px;
      // height: 60px;
      margin:12px auto;
      padding:10px 20px;
      box-sizing: border-box;
      >p{
        padding: 0px;
        margin: 0px;
        line-height: 20px;

        font-size: 14px;
        color: #464A4C;
        letter-spacing: 0;
        font-weight: 400;
      }
    }
  }
}
</style>
